import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiAction } from '@comparit/shared';
import { KundeLoginResponse, KundeService } from '@comparit/common-api';
import { skipReauth } from '../../../../interceptors/kunde-reauth.interceptor';
import { LoginDialogData } from '../../../../services/kunde-login-dialog.service';

@Injectable()
export class MlpLoginDialogFacade {
  private readonly kundeService = inject(KundeService);
  private readonly data = inject<LoginDialogData>(MAT_DIALOG_DATA);

  readonly login = new ApiAction<KundeLoginResponse>();

  submit(benutzername: string, kennwort: string): void {
    this.login.execute(
      this.kundeService.loginKunde(
        {
          kundeLoginRequest: {
            benutzername,
            kennwort,
            taskId: this.data.taskId ?? undefined,
            taskToken: this.data.taskToken ?? undefined,
            taskData: this.data.taskData ?? undefined,
          },
        },
        'body',
        false,
        // A wrong password answers 401. Without opting out, the interceptor
        // would read that as an expired session, clear a valid token and
        // reopen this very dialog — a loop.
        { context: skipReauth() }
      ),
      err => this.mapError(err)
    );
  }

  private mapError(err: unknown): string {
    const status = err instanceof HttpErrorResponse ? err.status : undefined;
    switch (status) {
      case 401:
        return 'Benutzername oder Kennwort ist nicht korrekt.';
      case 403:
        return 'Diese Berechnung gehört einem anderen Kunden.';
      case 502:
      case 504:
        return 'Der Login-Dienst ist momentan nicht erreichbar. Bitte versuche es später erneut.';
      default:
        return 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.';
    }
  }
}
